export default __webpack_public_path__ + "static/media/internet-search-tab.617975d0.png";